import {Tabs} from 'antd'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext} from 'react'
import {NullAsDefault} from "../../views/Shared";
import {LayoutContext} from "../layouts/Default/LayoutContext";
import classNames from "classnames";

export const ActionModalWrapper = ({
                                       tab,
                                       tabs,
                                       style,
                                       className,
                                       children,
                                       action = null,
                                       onTabChange = NullAsDefault,
                                       tabPosition = "top",
                                   }) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const resolvedTabPosition = tabPosition ?? (isSm ? "top" : "left")
    const renderTabs = useCallback(
        (children) => (
            <Tabs
                className={classNames('w-full custom-tabs-edit', !isSm && 'py-3')}
                centered={isSm}
                tabBarGutter={isSm ? 8 : 6}
                tabPosition={resolvedTabPosition}
                onChange={onTabChange}
                tabBarStyle={{width: resolvedTabPosition === "left" && 180}}
                items={Array.from(tabs ?? []).map(
                    ({key, label, component: Component = NullAsDefault}) => ({
                        key,
                        label: t(label),
                        children: (
                            <div className="flex flex-col w-full gap-4 py-3">
                                <Component child={children}/>
                            </div>
                        ),
                    })
                )}
            />
        ),
        [tab, tabs, resolvedTabPosition]
    );

    return (
        <div
            style={style}
            className={classNames('flex flex-col gap-3', className)}>
            {tab ? renderTabs(children) : children}
            {action}
        </div>
    )
}

